import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { sunsetDetailButtonType } from "../SunsetDetailButtons";
import { ISunsetData } from "./SunsetDetailInfo";
import CalendarLineBtn from "../../../../Button/CalendarLineBtn";
import CalendarModal from "../../../../Modal/CalendarModal";
import {
  sunsetDetailDataState,
  VerticalTableLabel,
  VerticalTableRow,
  VerticalTableValue,
} from "./SunsetSubs";
import { LineBoxContainer } from "../../../../../pages/UserLog/UserLog";

export default function SunsetDate() {
  const location = useLocation() as unknown as ISunsetData;
  const buttonType = useRecoilValue(sunsetDetailButtonType);

  const [sunsetDetailData, setSunsetDetailData] = useRecoilState(
    sunsetDetailDataState
  );
  const [sunsetDate, setSunsetDate] = useState(
    location?.state
      ? dayjs(location?.state?.sunsetData?.ssetDate).format("YYYY-MM-DD")
      : "날짜 선택"
  );
  const [sunsetDateClick, setSunsetDateClick] = useState(false);

  useEffect(() => {
    if (sunsetDate !== "날짜 선택") {
      setSunsetDetailData({
        ...sunsetDetailData,
        sunsetDate,
      });
    }
  }, [sunsetDate]);

  return (
    <VerticalTableRow>
      <VerticalTableLabel>일몰 실행일 (sset_date)</VerticalTableLabel>

      <LineBoxContainer>
        {buttonType === "view" ? (
          <VerticalTableValue>{sunsetDate}</VerticalTableValue>
        ) : (
          <CalendarLineBtn
            onClickEvent={() => setSunsetDateClick(true)}
            value={sunsetDate}
            initValue={"날짜 선택"}
            minWidth={220}
          />
        )}

        {sunsetDateClick && (
          <CalendarModal
            closeEvent={() => setSunsetDateClick(false)}
            changeEvent={(date: string) => setSunsetDate(date)}
            isAllSelectable={true}
            sPosition="absolute"
          />
        )}
      </LineBoxContainer>
    </VerticalTableRow>
  );
}
